import * as React from "react";
import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type ?? "text"}
      ref={ref}
      className={cn(
        "flex h-8 w-full rounded-md border border-border bg-background px-2.5 text-sm",
        "placeholder:text-subtle-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/60 focus-visible:border-accent",
        "disabled:cursor-not-allowed disabled:opacity-60",
        "shadow-of-sm",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
